var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.501 13.8515V6.14841C17.5004 6.03714 17.4705 5.928 17.4142 5.83199C17.358 5.73597 17.2774 5.65648 17.1807 5.60154L10.3057 1.73435C10.213 1.68087 10.1079 1.65271 10.001 1.65271C9.89401 1.65271 9.78893 1.68087 9.69629 1.73435L2.82129 5.60154C2.72453 5.65648 2.64397 5.73597 2.58774 5.83199C2.5315 5.928 2.50157 6.03714 2.50098 6.14841V13.8515C2.50157 13.9628 2.5315 14.072 2.58774 14.168C2.64397 14.264 2.72453 14.3435 2.82129 14.3984L9.69629 18.2656C9.78893 18.3191 9.89401 18.3472 10.001 18.3472C10.1079 18.3472 10.213 18.3191 10.3057 18.2656L17.1807 14.3984C17.2774 14.3435 17.358 14.264 17.4142 14.168C17.4705 14.072 17.5004 13.9628 17.501 13.8515V13.8515Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8291 11.9141V7.85156L6.25098 3.67188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.415 5.82812L10.0713 10L2.58691 5.82812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0713 10L10.001 18.3438",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.250095ab85300b747904c10e24022be3.svg";
export { ForwardRef as ReactComponent };